<div #widgetContainer class="container">
  <span class="channel-number">{{ displayNumber }}</span>
  <span class="channel-message">{{ displayMessage }}</span>
</div>
